import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  showServiceUnavailableBanner: false,
};

const serviceStatusSlice = createSlice({
  name: 'serviceStatus',
  initialState,
  reducers: {
    setShowServiceUnavailableBanner: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showServiceUnavailableBanner: action.payload,
    }),
  },
});

export const { setShowServiceUnavailableBanner } = serviceStatusSlice.actions;
export default serviceStatusSlice.reducer;
